/* eslint-disable @typescript-eslint/no-shadow */
import { CSSProperties } from 'react';
import styled from 'styled-components';
import { useCarouselContext } from '../../context';
import { TopRightActions } from './top-right-actions';
import { LensDescription, LensSource } from './lens-source-description';

export function DescriptionsBar() {
  const context = useCarouselContext();
  const layout = context.layout;
  const showTopRightArea = !context.options.hideTopRightActions && layout.fullArea().width > 815;
  const area = layout.topDescriptionsArea();
  const center = area.x1 + area.width / 2;
  const margin = 10;
  const height = area.height;

  function getStyles() {
    if (area.narrowMode) {
      const leftStyle: CSSProperties = {
        top: area.y1,
        left: area.x1,
        width: area.width,
        height: height / 2,
        justifyContent: 'center',
      };
      const rightStyle: CSSProperties = {
        ...leftStyle,
        top: area.y1 + height / 2,
      };
      return { leftStyle, rightStyle };
    } else {
      const leftStyle: CSSProperties = {
        right: center + margin,
        top: area.y1,
        left: area.x1,
        height,
        justifyContent: 'flex-end',
      };
      const rightStyle: CSSProperties = {
        left: center + margin,
        top: area.y1,
        right: 0,
        height,
        justifyContent: 'flex-start',
      };
      return { leftStyle, rightStyle };
    }
  }

  const { leftStyle, rightStyle } = getStyles();

  if (context.options.hideTopDescriptionArea) return <></>;

  return (
    <Root>
      <Left style={leftStyle}>
        <LensDescription />
      </Left>
      <Right style={rightStyle}>
        <LensSource />
        {showTopRightArea && (
          <OnTheRight>
            <TopRightActions />
          </OnTheRight>
        )}
      </Right>
    </Root>
  );
}

const Root = styled.div``;

const Left = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
`;
const Right = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
`;

const OnTheRight = styled.div`
  margin-left: auto; // As right as possible
  margin-right: 16px;
`;
